import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { MechanicValidatorCityWall } from '@colonist/game-mechanic-validators';
export class UICityWallHoverActionController extends UIHoverActionController {
    getBankActionAmount(index) {
        const cityWallPlayerState = this.validatorCityWall.getCityWallPlayerState(this.uiGameManager.gameController.myColor);
        return cityWallPlayerState.bankCityWallAmount;
    }
    updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor);
        const canPlaceCityWall = this.validatorCityWall.canPlayerPlaceCityWall(player.color);
        this.updateHoverLocations(canPlaceCityWall.validHoverLocations, canPlaceCityWall.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getTexture(index) {
        return UIGameSpriteHandler.getCityWallForPlayer(this.uiGameManager.gameController.myColor);
    }
    constructor(uiGameManager, cityWallState){
        super(uiGameManager);
        this.validatorCityWall = new MechanicValidatorCityWall(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, cityWallState);
        this.isCornerAction = true;
        this.resources = getCardsForPiece(PieceTypes.CityWall);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmBuildCityWallSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
    }
}
